<template>
  <div class="resume-email-display">
    <p class="email-message">
      {{ t('career.invite.message', { email: resumeEmail }) }}
    </p>
    <div class="email-highlight">
      <el-icon class="email-icon"><Message /></el-icon>
      <span class="email-address">{{ resumeEmail }}</span>
      <el-button
        class="copy-button"
        size="small"
        @click="copyEmail"
        type="text"
      >
        {{ copied ? t('common.copied') : t('common.copy') }}
        <el-icon><CopyDocument /></el-icon>
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Message, CopyDocument } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'

// 使用i18n
const { t } = useI18n()

// 配置简历接收邮箱（可根据实际情况修改）
const resumeEmail = ref('hr@pizugroup.cn')
const copied = ref(false)

// 复制邮箱功能
const copyEmail = () => {
  navigator.clipboard.writeText(resumeEmail.value)
    .then(() => {
      copied.value = true
      ElMessage.success(t('common.copy_success'))
      // 2秒后重置复制状态
      setTimeout(() => {
        copied.value = false
      }, 2000)
    })
    .catch(() => {
      ElMessage.error(t('common.copy_failed'))
    })
}
</script>

<style scoped lang="scss">
// 导入全局样式变量（和你的页面保持一致）
@import '@/assets/css/common';

.resume-email-display {
  background: $white;
  border-radius: 16px;
  padding: 30px 40px;
  box-shadow: $shadow-light;
  border: 1px solid rgba($primary-color, 0.1);
  margin: 40px 0;
  text-align: center;

  @media (max-width: 768px) {
    padding: 24px 30px;
    margin: 30px 0;
  }

  @media (max-width: 480px) {
    padding: 20px 24px;
    margin: 20px 0;
  }
}

.email-message {
  font-size: 1.125rem;
  color: $gray-80;
  line-height: 1.8;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.9375rem;
    margin-bottom: 16px;
  }
}

.email-highlight {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: rgba($primary-color, 0.05);
  padding: 12px 24px;
  border-radius: 8px;
  border: 1px solid rgba($primary-color, 0.1);

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 8px;
    padding: 10px 16px;
  }
}

.email-icon {
  color: $primary-color;
  font-size: 1.25rem;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
}

.email-address {
  font-size: 1.25rem;
  font-weight: 600;
  color: $primary-color-2;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    font-size: 1.125rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
}

.copy-button {
  color: $primary-color;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    color: $primary-light-3;
  }

  :deep(.el-icon) {
    font-size: 14px;
  }
}
</style>